import React, { useState, useEffect, useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import BoardingCalendarModel from "./BoardingCalendarModel";

const BoardingCalendarMain = ({
  
  pendingService,
  setPendingService,
  addToCart,
}) => {

  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedPetType, setSelectedPetType] = useState(null);
  const [selectedPetSize, setSelectedPetSize] = useState(null);

  const [selectedRoomType, setSelectedRoomType] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalReopenBlockedUntilRef = useRef(0);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];
    for (let i = 0; i < startingDayOfWeek; i++) days.push(null);
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    return days;
  };

  const isDateInRange = (date) => {
    if (!date || !selectedStartDate || !selectedEndDate) return false;
    return date >= selectedStartDate && date <= selectedEndDate;
  };

  const isStartDate = (date) =>
    date && selectedStartDate && date.getTime() === selectedStartDate.getTime();

  const isEndDate = (date) =>
    date && selectedEndDate && date.getTime() === selectedEndDate.getTime();

  const formatDate = (date) => {
    if (!date) return null;
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

 const calculateDays = () => {
  if (selectedStartDate && selectedEndDate) {
    const timeDiff = selectedEndDate.getTime() - selectedStartDate.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }
  return null;
};

  useEffect(() => {
  if (selectedStartDate && !selectedEndDate) {
    // Check if start date is in last week of month
    const year = selectedStartDate.getFullYear();
    const month = selectedStartDate.getMonth();
    const day = selectedStartDate.getDate();
    const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
    
    if (day === lastDayOfMonth) {
      
      // SAFE METHOD: Create the 1st of next month
      let nextYear = year;
      let nextMonth = month + 1;
      
      // Handle December -> January rollover
      if (nextMonth > 11) {
        nextMonth = 0;
        nextYear = year + 1;
      }
      
      // Create 1st of next month (always valid)
      const nextMonthDate = new Date(nextYear, nextMonth, 1);
      setCurrentMonth(nextMonthDate);
    }
  }
}, [selectedStartDate, selectedEndDate]);


  const navigateMonth = (direction) => {
  
  // Create new month using the 15th (mid-month, always safe)
  const year = currentMonth.getFullYear();
  const month = currentMonth.getMonth();
  
  let newYear = year;
  let newMonth = month + direction;
  
  // Handle year rollover
  if (newMonth > 11) {
    newMonth = 0;
    newYear = year + 1;
  } else if (newMonth < 0) {
    newMonth = 11;
    newYear = year - 1;
  }
  
  // Use 15th to avoid rollover issues
  const newMonthDate = new Date(newYear, newMonth, 15);
  
  setCurrentMonth(newMonthDate);
};

  const handleDateClick = (date) => {
    if (!date || date < new Date().setHours(0, 0, 0, 0)) return;

    if (!selectedStartDate || (selectedStartDate && selectedEndDate)) {
      setSelectedStartDate(date);
      setSelectedEndDate(null);
    } //else if (
      //selectedStartDate &&
      //!selectedEndDate &&
     // date >= selectedStartDate
    //) {
    else if (selectedStartDate && !selectedEndDate) {
    // PREVENT SAME DATE SELECTION
    if (date.getTime() === selectedStartDate.getTime()) {
      // Option A: Do nothing (ignore the click)
      return; 
    }
    // 3. If the user clicks a date BEFORE the start date, treat it as the new start date
    if (date < selectedStartDate) {
      setSelectedStartDate(date);
    } 
    else {
      setSelectedEndDate(date);
      }
    }
  };

  const handleOpenModal = () => {
    if (Date.now() < modalReopenBlockedUntilRef.current) return;
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    // Prevent immediate touch click-through from reopening on mobile.
    modalReopenBlockedUntilRef.current = Date.now() + 500;
    setIsModalOpen(false);
  };

  const days = getDaysInMonth(currentMonth);

  

  return (
    <div className="mx-auto max-w-full sm:max-w-2xl px-4 sm:px-6">
      {/* Top summary */}
      <div className="my-3 flex flex-row sm:flex-row sm:justify-between items-start mx-[-10px] sm:items-center gap-2 sm:gap-3">
        <div>
          <p className="text-[#3B82F6] text-sm sm:text-sm font-semibold mt-2">
            Check-in
          </p>
          <p className="text-[#FF6216] text-sm sm:text-sm font-medium mt-2">
            {formatDate(selectedStartDate)}
          </p>
        </div>
        <div>
          <p className="text-[#3B82F6] text-sm sm:text-sm font-semibold mt-2 whitespace-nowrap ">
            Check-Out
          </p>
          <p className="text-[#FF6216] text-sm sm:text-sm font-medium mt-2">
            {formatDate(selectedEndDate)}
          </p>
        </div>
        <div>
          <p className="text-[#3B82F6] text-sm sm:text-sm font-semibold mt-2">
            No. of days
          </p>
          <p className="text-[#FF6216] ml-4 sm:ml-4 text-sm sm:text-base font-medium mt-2">
            {calculateDays()}
          </p>
        </div>
        <button
          onClick={() => {
            setSelectedStartDate(null);
            setSelectedEndDate(null);
          }}
          className={`
            ml-auto py-2 px-3 my-2 bg-gray-200 hover:bg-orange-400 text-[#000000] text-lg sm:text-sm font-medium rounded-lg transition-colors duration-200
            ${
              !selectedStartDate && !selectedEndDate
                ? "opacity-50 cursor-not-allowed"
                : ""
            }
          `}
          disabled={!selectedStartDate && !selectedEndDate}
        >
          Clear
        </button>
      </div>

      {/* Calendar */}
      <div className="border border-gray-300 rounded-lg bg-white shadow-sm mt-10 sm:mt-0">
        <div className="flex items-center justify-between p-6 sm:p-4 border-b border-gray-200 bg-gray-50 rounded-t-lg">
          <button
            onClick={() => navigateMonth(-1)}
            className="p-2 hover:bg-gray-200 rounded-full transition-colors duration-200"
          >
            <FaChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
          </button>
          <h3 className="text-base sm:text-lg font-semibold text-[#000048]">
            {months[currentMonth.getMonth()]} {currentMonth.getFullYear()}
          </h3>
          <button
            onClick={() => navigateMonth(1)}
            className="p-2 hover:bg-gray-200 rounded-full transition-colors duration-200"
          >
            <FaChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
          </button>
        </div>

        <div className="grid grid-cols-7 gap-0 border-b border-gray-300">
          {weekdays.map((day) => (
            <div
              key={day}
              className="p-4 sm:p-3 text-center text-sm sm:text-sm font-medium text-gray-700 bg-gray-50"
            >
              {day}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-0">
          {days.map((date, index) => {
            const isInRange = isDateInRange(date);
            const isStart = isStartDate(date);
            const isEnd = isEndDate(date);
            const isToday =
              date && date.toDateString() === new Date().toDateString();

            return (
              <div
                key={index}
                onClick={() => handleDateClick(date)}
                className={`
                  relative h-14 sm:h-12 flex items-center justify-center text-sm sm:text-sm transition-all duration-200
                  ${
                    !date
                      ? "cursor-default"
                      : "cursor-pointer hover:bg-orange-50"
                  }
                  ${isInRange ? "bg-orange-100" : ""}
                  ${
                    isStart || isEnd
                      ? "bg-orange-500 text-white font-semibold"
                      : ""
                  }
                  ${
                    isToday && !isInRange && !isStart && !isEnd
                      ? "bg-blue-100 font-semibold"
                      : ""
                  }
                  ${
                    date && date < new Date().setHours(0, 0, 0, 0)
                      ? "text-gray-300 cursor-not-allowed"
                      : ""
                  }
                `}
              >
                {date && (
                  <>
                    <span
                      className={`${
                        isStart || isEnd ? "text-white" : "text-gray-700"
                      }`}
                    >
                      {date.getDate()}
                    </span>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Legend */}
      <div className="mt-3 flex flex-wrap gap-3 mt-6 sm:gap-4 text-xs sm:text-sm text-gray-600">
        <div className="flex items-center gap-2 ">
          <div className="w-3 h-3 sm:w-4 sm:h-4 bg-orange-500 rounded "></div>
          <span>Check-in/Check-out</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 sm:w-4 sm:h-4 bg-orange-100 rounded"></div>
          <span>Boarding period</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 sm:w-4 sm:h-4 bg-blue-100 rounded"></div>
          <span>Today</span>
        </div>
      </div>

      {/* Checkout button */}
      <button
        onClick={handleOpenModal}
        className={`
          w-full py-3 sm:py-4 my-3 mt-6 sm:my-4 text-base sm:text-lg rounded-lg transition-opacity duration-200
          ${
            selectedStartDate && selectedEndDate
              ? "bg-[#FD5901] hover:opacity-75 text-white"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }
        `}
        disabled={!selectedStartDate || !selectedEndDate}
      >
        Proceed to Checkout
      </button>

      {/* Modal */}
      <BoardingCalendarModel
        isOpen={isModalOpen}
        closeModal={handleCloseModal}
        addToCart={addToCart}
        selectedStartDate={selectedStartDate}
        selectedEndDate={selectedEndDate}
        formatDate={formatDate}
        calculateDays={calculateDays}
        selectedPetType={selectedPetType}
        setSelectedPetType={setSelectedPetType}
        selectedPetSize={selectedPetSize}
        setSelectedPetSize={setSelectedPetSize}
        selectedRoomType={selectedRoomType}
        setSelectedRoomType={setSelectedRoomType}
        pendingService={pendingService} // ✅ Add this
        setPendingService={setPendingService} // ✅ Already there
      />
    </div>
  );
};

export default BoardingCalendarMain;
